import React, { Component } from 'react';
import { connect } from 'react-redux';
import './SignUp.css';

import adminActions from '../../actions/admin';
import Button from '../../components/Button';
import Step from '../../components/Step';
import Guide from '../../components/Guide';
import Modal from '../../components/Modal';

import signUpFields from '../../forms/admin/create';
import { extractPhasesOrFail } from '../../helpers/ValueBuilder';
import { validatePhases, checkForErrors } from '../../helpers/Validation';
import formHelpers from '../../helpers/FormHelpers';


class SignUp extends Component {
  constructor() {
    super();
    this.handleFieldChange = this.handleFieldChange.bind(this);
    this.handleFieldBlur = this.handleFieldBlur.bind(this);
    this.handleEnter = this.handleEnter.bind(this);
    this.handleCheckboxClick = this.handleCheckboxClick.bind(this);
    this.handleFieldFocus = this.handleFieldFocus.bind(this);
    this.handleSignUpClick = this.handleSignUpClick.bind(this);
  }

  componentWillMount() {
    this.setState({
      fields: signUpFields
    })
  }

  handleCheckboxClick(name, value) {
    //formHelpers.handleCheckboxClick(value, name, 'rememberMeFields', this);
  }

  handleFieldBlur(name) {
    formHelpers.handleFieldBlur(name, 'fields', this);
  }

  handleFieldChange(value, name) {
    formHelpers.handleFieldChange(value, name, 'fields', this);
  }

  handleFieldFocus(name) {
    formHelpers.handleFieldFocus(name, 'fields', this);
  }

  handleEnter(e) {
    e.preventDefault();
    this.handleSignUpClick();
  }

  handleSignUpClick() {
    const { fields } = this.state;
    let data = extractPhasesOrFail({ fields });
    if (data) {
      this.props.dispatch(adminActions.create(data), this.props.router);
    } else {
      this.setState({
        fields: this.blurphase(fields)
      })
    }
  }

  render() {
    const { fields } = this.state;
    return (
      <div className="saga-wrap">
        <div className="saga">
          <div className="signup__guide">
            <Guide
              header="Lorem Ipsum is simply dummy text of the printing and typesetting industry."
              message="Lorem Ipsum is simply dummy text of the printing
              and typesetting industry. Lorem Ipsum has been the
              industry's standard dummy text ever since the 1500s,
              when an unknown printer took a galley of type and scrambled
              it to make a type specimen book. It has survived not only five
              centuries, but also the leap into electronic typesetting, remaining
              essentially unchanged."/>
          </div>
          <div className="signup__form">
            { formHelpers.buildFields(fields, this) }
            <Button
              allowHover={true}
              text="Sign Up"
              onClick={this.handleSignUpClick}/>
          </div>
          <div className="clear"></div>
          <div className="full-wrap">
            <p className="signup__disclaimer">
              Lorem Ipsum is simply dummy text of the printing
              and typesetting industry. Lorem Ipsum has been the
              industry's standard dummy text ever since the 1500s,
              when an unknown printer took a galley of type and scrambled
              it to make a type specimen book. It has survived not only five
              centuries
            </p>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(
  (state) => ({
  })
)(SignUp);



/** WEBPACK FOOTER **
 ** ./src/containers/SignUp/index.js
 **/